import React from 'react';

import Typography from '@mui/material/Typography';

import BaseLayout from 'ff/debrief/layouts/BaseLayout';
import FullPage from 'ff/debrief/layouts/FullPage';
import Button from '@mui/material/Button';

const ProductDetailsPage = () => {
    return (
        <BaseLayout>
            <FullPage>
                <Typography
                    variant="h4"
                    mb={3}
                    fontWeight="700"
                    textTransform="uppercase"
                >
                    Get Started With Track Log
                </Typography>
                <Typography
                    variant="h6"
                    textAlign="center"
                    mb={1}
                    maxWidth="800px"
                    lineHeight="25px"
                >
                    Track Logs, a cloud-enabled flight recorder, allows you to
                    record and share your flight track and altitude data right
                    from the ForeFlight Mobile app. Easily share your flying
                    with friends and family, or use Track Logs as a helpful
                    post-flight debrief tool.
                </Typography>
                <Typography
                    variant="h6"
                    textAlign="center"
                    mb={4}
                    maxWidth="800px"
                    lineHeight="25px"
                >
                    Enable Track Log in <strong>More &gt; Settings</strong> by
                    turning the Track Log switch ON.
                </Typography>
                <Button
                    component="a"
                    href="https://blog.foreflight.com/2014/08/05/foreflight-mobile-6-3/"
                    target="_blank"
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{ textTransform: 'uppercase' }}
                >
                    Learn More
                </Button>
            </FullPage>
        </BaseLayout>
    );
};

export default ProductDetailsPage;
